import React, { Fragment, useContext, useEffect, useState } from "react";
// Provider
import {
  AppContext,
  LOG_IN_FAILURE,
  LOG_IN_SUCCESS,
  MENU_SET_ALL,
  SET_APP_ALL,
  SocketCommand,
  socketManager,
} from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { openLayerFn } from "../Layout";

import { PostApi101, PostApi1910, PostApi1913 } from "../../modules/network/padoPost";

import { AlertLayer } from "../../components/UI/Dialog";

import { NativeAction } from "../../modules/utils/HandleWs";
import { getCookie, setCookie } from "../../modules/utils/cookie";
import AuthAgreement from "../Company/TermsDetail/AuthAgreement";
import TermsPopup from "../Company/TermsDetail/TermsPopup";
import { loginLogInterface } from "./LoginOld";

let URL = [
  "/",
  "/SM",
  "/sm/bp/input",
  "/sm/bs/input",
  "/eocs",
  "/surround",
  "/eocs",
];

export default props => {
  const { cfg, auth, dispatch, phonecfg } = useContext(AppContext);
  const [loginSuccess, setLoginSuccess] = useState(false);

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleLoginFail = () => {
    // handleReset();
    dispatch({ type: LOG_IN_FAILURE });
    handleAlert("확인", "로그인 실패");
  };

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const request1910 = (userinfo, cardType) => {
    PostApi1910(userinfo, cfg, phonecfg, cardType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;

          if (data.length > 0)
            dispatch({ type: MENU_SET_ALL, menutype: cardType, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  const request1913 = userinfo => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          dispatch({ type: SET_APP_ALL, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request101 = (userEmail, userName, UID, signUpChannel) => {
    PostApi101(phonecfg, cfg, userEmail, null, UID, signUpChannel)
      .then(res => {
        if (res.resultCode === "000") {
          setLoginSuccess(true);
          handleLoginSuccess(res);
          loginLogInterface(
            res.result[0],
            phonecfg,
            cfg,
            "I",
            "M",
            res.result[0].signUpChannel
          );

          socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            login: "in",
            userToken: res.result[0].userToken.toString(),
          });
          setCookie("lastLoginChannel", res.result[0].signUpChannel, 365);
        } else if (res.resultCode === "001") {
          // 이후 회원가입
          let snsInfo = [
            {
              userEmail: userEmail,
              userName: userName,
              UID: UID,
              signUpChannel: signUpChannel,
            },
          ];

          setCookie("snsInfo", snsInfo, 1);
          NativeAction(phonecfg, "test", "");
          // openLayerFn($("#termsPopup"));
          if (getCookie("authCheck")) {
            _O.Open("/membership/snsLoginComplete/" + getCookie("authCheck"));
          } else {
            _O.Open(
              "/membership/serviceTerms/" + props.match.params.signUpChannel
            );
          }
        } else {
          setLoginSuccess(false);
          handleLoginFail();
        }
      })
      .catch(err => {
        console.log("snsLogin err :: " + err);
        setLoginSuccess(false);
        handleLoginFail();
      });
  };

  const handleLoginSuccess = res => {
    const autoLogin = getCookie("isAutologin");

    dispatch({
      type: LOG_IN_SUCCESS,
      data: res.result[0],
      isAutoLogin: autoLogin === "false" ? false : true,
    });
    request1910(res.result[0], "");
    request1913(res.result[0]);
    // 전체 가져오기 수정 필요
    if (res.result[0].isAuthOk == "0") {
      // 향후 수정 필요 임시임(DSRYU) 메세지 매번 보여줄 필요 없음 처리
      // 여기서 걸리는듯
      $("#exchangeTargetLogin").attr("id", "welcomeLogin");
      handleAlert("확인", `케어포미에 오신 것을 환영합니다.`);

      if (
        phonecfg.phoneOS === "IOS" &&
        parseInt(phonecfg.version.split(".")[2]) > 13
      ) {
        NativeAction(phonecfg, "inputEPmenu", "in");
      }
    } else {
      // 로그인 이후 본인인증 여부에 따라
      _O.OpenMenu("/membership/certification");
    }
  };

  const handleAlertCB = () => {
    if (loginSuccess) {
      _O.OpenMenu("/");
    } else {
      handleReset();
    }
  };

  useEffect(() => {
    request101(
      props.match.params.userEmail,
      props.match.params.userName,
      props.match.params.UID,
      props.match.params.signUpChannel
    );
  }, []);

  return (
    <Fragment>
      <div></div>

      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertCB}
      />

      <TermsPopup />
      <AuthAgreement />
    </Fragment>
  );
};
